export default "__VITE_ASSET__C2Ip4CpF__"